import React, { useEffect } from "react";

// Components
import { Loader, PageOverLay, SEO, TrainingInfo } from "../../Components";
// Store
import { pathTitles, useStore } from "../../Store/Store";

export const PrivateLessons = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);
  const inHomePrograms = useStore((state) => state.inHomePrograms);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "privateLessons",
    title: "In Home Training",
    caption:
      "A client's dog working on obedience and focus during an in-home training session.",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
      "Private Lessons": getLink(pathTitles.PRIVATELESSONS),
    },
    body: trainingDetails.PRIVATELESSONS.body,
    programs: inHomePrograms,
  };
  return (
    <>
      <SEO
        title="Private In-Home Dog Training Lessons"
        description="One-on-one in-home dog training lessons in Indianapolis, Carmel, Noblesville, Fishers and nearby. Address behavior issues where they happen — in your home — with a professional trainer."
        path="/training/private"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
